module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/3_91a0b956e63d8665fb3f113ee83e3375.png";